/* Serie-wisselaar voor de sectie "image with text".
   Toont onder de foto een pil met 2 of 3 knoppen; elke knop hoort bij een
   afbeelding. Knop 1 is de hoofdafbeelding van de sectie (die al in de DOM
   staat), knop 2 en 3 zijn de extra afbeeldingen die hierboven liggen.
   De knop wisselt alleen de foto, verder gebeurt er niets.

   De pil hangt half over de onderrand van de foto (zie
   component-image-with-text-extras.css) en de ruimte eronder moet vrijblijven
   zodat de tekst na de foto, of op desktop de titel van de volgende sectie,
   er niet tegenaan of overheen valt. Die ruimte werd eerder
   berekend uit aannames over knophoogte/padding/gap, maar die aannames lopen
   makkelijk uit de pas met de echte CSS (en met knoplabels die 2 regels
   worden). Daarom wordt de pil hier gewoon gemeten en de ruimte op basis
   daarvan gereserveerd, net als bij align-collection-tabs.js. */
if (!customElements.get('image-series-switch')) {
  var BUFFER_PX = 4;

  class ImageSeriesSwitch extends HTMLElement {
    connectedCallback() {
      const section = this.closest('[data-section-id]');
      const picContainer = section && section.querySelector('.hero__pic-container');
      const picWrapper = section && section.querySelector('.hero__pic-wrapper');

      if (picContainer && !picContainer.contains(this)) {
        picContainer.appendChild(this);
      }

      this.removeAttribute('hidden');

      this.pill = this.querySelector('.image-switch__pill');
      // Bij een video-achtergrond rendert hero geen .hero__pic-wrapper, alleen
      // de container. Dan de ruimte op de container zelf reserveren.
      this.picWrapper = picWrapper || picContainer;
      this.buttons = Array.from(this.querySelectorAll('.image-switch__btn'));

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          this.select(button.dataset.switchValue);
        });
      });

      const active = this.buttons.find((button) => button.classList.contains('is-active'));
      this.select(active ? active.dataset.switchValue : '1');

      this.scheduleReserveSpace();
      window.addEventListener('resize', () => this.scheduleReserveSpace());

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.scheduleReserveSpace());
      }

      if (window.ResizeObserver && this.pill) {
        new ResizeObserver(() => this.scheduleReserveSpace()).observe(this.pill);
      }
    }

    select(value) {
      this.setAttribute('data-active', value);

      this.buttons.forEach((button) => {
        const isActive = button.dataset.switchValue === value;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      this.scheduleReserveSpace();
    }

    scheduleReserveSpace() {
      if (this.reserveScheduled) return;
      this.reserveScheduled = true;
      requestAnimationFrame(() => {
        this.reserveScheduled = false;
        this.reserveSpace();
      });
    }

    reserveSpace() {
      if (!this.pill || !this.picWrapper) return;

      const pillHeight = this.pill.getBoundingClientRect().height;
      if (!pillHeight) return;

      this.picWrapper.style.marginBottom = pillHeight / 2 + BUFFER_PX + 'px';
    }
  }

  customElements.define('image-series-switch', ImageSeriesSwitch);
}
